import React from "react";

export const DEFAULT_TZ = "Africa/Johannesburg";
export const TIMEZONES = [
  "Africa/Johannesburg", "Africa/Windhoek", "Africa/Gaborone", "Africa/Maputo", "Africa/Harare", "Africa/Lusaka",
  "Africa/Nairobi", "Africa/Lagos", "Africa/Accra", "Africa/Cairo", "Indian/Mauritius", "Europe/London", "Europe/Paris",
  "Asia/Dubai", "Asia/Kolkata", "Asia/Singapore", "Australia/Sydney", "America/New_York", "America/Chicago",
  "America/Los_Angeles", "UTC",
];

let orgTz = DEFAULT_TZ;
const locTz = {};

export function setTimeZones(orgZone, locations = []) {
  orgTz = orgZone || DEFAULT_TZ;
  locations.forEach((l) => { if (l.timezone) locTz[l.id] = l.timezone; });
}
export const tzFor = (locationId) => (locationId && locTz[locationId]) || orgTz;

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;
const fmtCache = {};
function parts(iso, tz) {
  const d = iso instanceof Date ? iso : new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  fmtCache[tz] = fmtCache[tz] || new Intl.DateTimeFormat("en-GB", {
    timeZone: tz, day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23", weekday: "short",
  });
  return Object.fromEntries(fmtCache[tz].formatToParts(d).map((p) => [p.type, p.value]));
}

/** dd/mm/yyyy hh:mm:ss in the location's (or organisation's) time zone. */
export function fmtDateTime(iso, locationId) {
  if (!iso) return "—";
  const p = parts(iso, tzFor(locationId));
  return p ? `${p.day}/${p.month}/${p.year} ${p.hour}:${p.minute}:${p.second}` : "—";
}

/** dd/mm/yyyy; plain YYYY-MM-DD values are reformatted without time-zone shifting. */
export function fmtDate(iso, locationId) {
  if (!iso) return "—";
  if (DATE_ONLY.test(iso)) { const [y, m, d] = iso.split("-"); return `${d}/${m}/${y}`; }
  const p = parts(iso, tzFor(locationId));
  return p ? `${p.day}/${p.month}/${p.year}` : "—";
}

export function fmtTime(iso, locationId) {
  const p = iso && parts(iso, tzFor(locationId));
  return p ? `${p.hour}:${p.minute}:${p.second}` : "—";
}

export function fmtDayLabel(isoDate) {
  const p = parts(`${isoDate}T12:00:00Z`, "UTC");
  return p ? `${p.weekday} ${fmtDate(isoDate)}` : isoDate;
}

export function relative(iso) {
  const secs = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (Number.isNaN(secs)) return "—";
  if (secs < 60) return "just now";
  if (secs < 3600) return `${Math.floor(secs / 60)} min ago`;
  if (secs < 86400) return `${Math.floor(secs / 3600)} h ago`;
  const days = Math.floor(secs / 86400);
  if (days === 1) return "yesterday";
  if (days < 30) return `${days}d ago`;
  return null;
}

/** "5 min ago" with the full local timestamp on hover; older than 30 days shows the date. */
export function RelTime({ iso, locationId, className = "", testId }) {
  if (!iso) return <span className={className}>—</span>;
  const full = fmtDateTime(iso, locationId);
  return <time dateTime={iso} title={full} className={className} data-testid={testId}>{relative(iso) || fmtDate(iso, locationId)}</time>;
}
